import React from 'react';
import { UserComponent } from 'react/UserComponent.jsx';

import { JqueryClassFaker } from 'components/JqueryClassFaker.jsx';
import { StocksComponent } from 'react/match/active/StocksComponent.jsx';
import { ApmComponent } from 'react/match/active/ApmComponent.jsx';
import { CharacterComponent } from 'react/CharacterComponent.jsx';

class MatchSelectedCharacterPlayerComponent extends React.PureComponent {
	static defaultProps = {
		showCharacterName: true,
		showPlayerName: true
	};

	constructor(props) {
		super(props);

		const { onClick, match, teamNumber } = this.props;

		this.fetchingCharater = false;
		this.state = {
			character: null,
			randomCharacter: null,
			fetchingCharacter: false
		};
		this.onClick = onClick ? onClick.bind(null, teamNumber === match.getMyTeamNumber()) : undefined;
	}

	componentDidMount() {
		this._updateCharacter();
	}

	_updateCharacter() {
		const { characterId, randomCharacterId, match } = this.props;
		if(this.fetchingCharacter) {
			console.error('fetching character already');
			return;
		}
		if(!this.props.characterId) {
			console.error('do not have character');
			return;
		}
		if(this.state.character && this.state.character.id == this.props.characterId) {
			console.error('was same character');
			return;
		}

		this.fetchingCharacter = true;
		match.season.getCharacters()
			.then(() => {
				const character = match.season.getCharacterById(characterId);
				const randomCharacter = match.season.getCharacterById(randomCharacterId);
				if(!character) {
					console.error('Could not load the character for some reason');
				}
				this.setState({
					character: character,
					randomCharacter: randomCharacter
				});
			})
			.finally(() => {
				this.fetchingCharacter = false;
			});
	}

	render() {
		const {
			showCharacterName, showPlayerName, disabled, player,
			match, onClick, teamNumber, matchGamePlayer, apmHeading, replay, showDetailedStats, characterId,
		} = this.props;
		const { character, randomCharacter } = this.state;
		if(!characterId || characterId === true) {
			return null;
		}

		const containerClasses = new JqueryClassFaker();
		if(player.isMe()) {
			containerClasses.addClass('my_character');
		}
		if(disabled) {
			containerClasses.addClass('disabled');
		}
		if(randomCharacter) {
			containerClasses.addClass('has_random_selection');
		}
		return (
			<div className={'player_character ' + containerClasses.toString()}>
				<div className='character_owner'>
					{showPlayerName &&
					<UserComponent user={player} />
					}
					{!!character && showCharacterName &&
					<span className='character_name'>{character.name}</span>
					}
				</div>
				{!!character &&
				<CharacterComponent
					extraClasses='character_holder'
					onClick={this.onClick}
					character={character}
					randomCharacter={randomCharacter}
					showCharacterName={showCharacterName}
				/>
				}
				<StocksComponent
					stocks={matchGamePlayer && matchGamePlayer.stocks}
				/>
				<ApmComponent
					matchGamePlayer={matchGamePlayer}
					apmHeading={apmHeading}
				/>
			</div>
		);
	}

}

export { MatchSelectedCharacterPlayerComponent };